import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const massiveEmailRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.massiveEmailTypes,
    name: routeNames.massiveEmailTypes,
    component: () => import('@/pages/massive-email-types/MassiveEmailTypesView.vue'),
    meta: {
      permission: 'massive-email-types.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'inbox_customize',
      labelKey: 'massiveEmailTypes',
      featureFlag: 'massive-emails',
    },
  },
  {
    path: routePaths.massiveEmails,
    name: routeNames.massiveEmails,
    component: () => import('@/pages/massive-emails/MassiveEmailsView.vue'),
    meta: {
      permission: 'massive-emails.read.all',
      icon: 'pi pi-envelope',
      labelKey: 'massiveEmails',
      featureFlag: 'massive-emails',
    },
  },
  {
    path: routePaths.massiveEmailDetails,
    component: () => import('@/pages/massive-emails/MassiveEmailDetailsView.vue'),
    meta: {
      rootRouteName: routeNames.massiveEmails,
      permission: 'massive-emails.read.all',
      featureFlag: 'massive-emails',
    },
    children: [
      {
        path: '',
        name: routeNames.massiveEmailDetails,
        redirect: { name: routeNames.massiveEmailDetailsReceivers },
      },
      {
        path: routePaths.massiveEmailDetailsReceivers,
        name: routeNames.massiveEmailDetailsReceivers,
        component: () => import('@/pages/massive-emails/tabs/MassiveEmailReceiversTab.vue'),
        meta: {
          rootRouteName: routeNames.massiveEmails,
          labelKey: 'receivers',
        },
      },
      {
        path: routePaths.massiveEmailDetailsResponses,
        name: routeNames.massiveEmailDetailsResponses,
        component: () => import('@/pages/massive-emails/tabs/MassiveEmailResponsesTab.vue'),
        meta: {
          rootRouteName: routeNames.massiveEmails,
          labelKey: 'responses',
        },
      },
      {
        path: routePaths.massiveEmailDetailsMetadata,
        name: routeNames.massiveEmailDetailsMetadata,
        component: () => import('@/pages/massive-emails/tabs/MassiveEmailMetadataTab.vue'),
        meta: {
          rootRouteName: routeNames.massiveEmails,
          labelKey: 'massiveEmailMetadata',
        },
      },
      {
        path: routePaths.massiveEmailDetailsPreview,
        name: routeNames.massiveEmailDetailsPreview,
        component: () => import('@/pages/massive-emails/tabs/MassiveEmailPreviewTab.vue'),
        meta: {
          rootRouteName: routeNames.massiveEmails,
          labelKey: 'preview',
        },
      },
      {
        path: routePaths.massiveEmailDetailsEvents,
        name: routeNames.massiveEmailDetailsEvents,
        component: () => import('@/pages/massive-emails/tabs/MassiveEmailEventsTab.vue'),
        meta: {
          rootRouteName: routeNames.massiveEmails,
          labelKey: 'massiveEmailEvents',
        },
      },
    ],
  },
  {
    path: routePaths.massiveEmailCreation,
    name: routeNames.massiveEmailCreation,
    component: () => import('@/pages/massive-emails/AddEditMassiveEmailView.vue'),
    meta: {
      permission: 'massive-emails.write.all',
      rootRouteName: routeNames.massiveEmails,
      labelKey: 'new_f',
      featureFlag: 'massive-emails',
    },
  },
  {
    path: routePaths.massiveEmailEdit,
    name: routeNames.massiveEmailEdit,
    component: () => import('@/pages/massive-emails/AddEditMassiveEmailView.vue'),
    meta: {
      permission: 'massive-emails.write.all',
      rootRouteName: routeNames.massiveEmails,
      labelKey: 'edit',
      featureFlag: 'massive-emails',
    },
  },
  {
    path: routePaths.massiveEmailDetailsReceiversCreation,
    name: routeNames.massiveEmailDetailsReceiversCreation,
    component: () => import('@/pages/massive-emails/add-receivers/AddMassiveEmailReceiversView.vue'),
    meta: {
      permission: 'massive-emails.write.all',
      rootRouteName: routeNames.massiveEmails,
      labelKey: 'new_m',
      featureFlag: 'massive-emails',
    },
  },
]
